import { render } from "./spulist.vue?vue&type=template&id=79bf607a"
import script from "./spulist.vue?vue&type=script&lang=js"
export * from "./spulist.vue?vue&type=script&lang=js"

import "./spulist.vue?vue&type=style&index=0&id=79bf607a&lang=less"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__